<template>
  <div class="freight">
    <Animation :message="parentMessage" />
    <div class="jingxyj">
      <div class="delivery-header">
        <div class="titleBox">
          <div
            class="title"
            :class="{ background: isBackground(index) , backgroundER: isBackground(index) && index==0 , backgroundBaiER: index==0 }"
            v-for="(item, index) in titleList"
            :key="index"
            @click="handleClickTitle(index)"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="delivery-show" v-if="marketIndex == 0">
        <div class="delivery-main">
          <div class="delivery-main-box youjiantou">
            <img src="@/assets/images/hpcopy/定位.png" alt="" />
            <div class="address">
              <div>起运港</div>
              <el-select v-model="searchQuery1JXYJ" clearable  filterable placeholder="请选择">
                <el-option
                  v-for="item in qiYGTitleList"
                  :key="item.id"
                  :label="item.name_cn+'-'+item.name_en"
                  :value="item.id"
                  v-show="item.display_range==0 || item.display_range==1"
                >
                </el-option>
              </el-select>
            </div>
            <div class="youbian">
              <img src="../../assets/images/Group 92.png" />
            </div>
          </div>

          <div class="delivery-main-box">
            <img src="@/assets/images/hpcopy/定位.png" alt="" />
            <div class="address">
              <div>目的港</div>
              <el-select  v-model="searchQuery2JXYJ" clearable  filterable placeholder="请选择"
                remote
                reserve-keyword
                :remote-method="mdgremoteMethod"
                :loading="mdgloading">
                 <!-- @tab-click="handleClick" -->
                <el-tabs class="mudig" v-model="activeName">
                  <el-tab-pane
                    :key="index"
                      v-for="(item,index) in muDgList"
                    :label="item.route_name"
                    :name="item.route_name"
                  >
                    <el-option-group
                      v-for="(it,idx) in item.tag_arr"
                        :key="idx"
                      :label="it.tag_name"
                      :value="it.tag_id"
                      class="mdglist">
                      <el-option
                        v-for="(at,adx) in it.port_arr"
                          :key="adx"
                        :label="at.port_name+'-'+at.name_en"
                        :value="at.port_id">
                      </el-option>
                    </el-option-group>
                  </el-tab-pane>
                </el-tabs>
              </el-select>
            </div>
          </div>
          <div class="delivery-main-box">
            <img src="@/assets/images/hpcopy/箱型.png" alt="" />
            <div class="address">
              <div>箱型</div>
              <el-select 
              :multiple-limit="3"
              multiple
              collapse-tags
              class="xiangxing"
              clearable
              v-model="searchQuery3JXYJ" 
              placeholder="请选择">
              <el-option
                v-for="item in boxTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
            </div>
          </div>
          <div class="delivery-main-box">
            <img src="@/assets/images/hpcopy/日期.png" alt="" />
            <div class="address">
              <div>开航起止日期</div>
              <el-date-picker
                value-format='yyyy-MM-dd'
                :picker-options="pickerOptions"
                prefix-icon="null"
                class="picker"
                v-model="DateValue1"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </div>

          <div class="search" @click="searchList('JXYJ')">
            <i class="el-icon-search"></i>搜索
          </div>
        </div>
        <div v-if="historyPortList.length>0" class="delivery-foot">
          <div class="jilu">历史记录</div>
          <div class="delivery-history-box">
            <div class="delivery-history"
            v-for="(item,index) in historyPortList"
            :key="index"
            @click="historySearch('JXYJ',item)"
            >
            {{item.state_port_name}}-{{item.end_port_name}}
          </div>
          </div>
        </div>
      </div>
      <div class="delivery-show" v-if="marketIndex == 1">
        <div class="delivery-main">
          <div class="delivery-main-box youjiantou">
            <img src="@/assets/images/hpcopy/定位.png" alt="" />
            <div class="address">
              <div>起运港</div>
              <el-select v-model="searchQuery1XCSC" clearable  filterable placeholder="请选择">
                <el-option
                  v-for="item in qiYGTitleList"
                  :key="item.id"
                  :label="item.name_cn+'-'+item.name_en"
                  :value="item.id"
                  v-show="item.display_range==0 || item.display_range==1"
                >
                </el-option>
              </el-select>
            </div>
            <div class="youbian">
              <img src="../../assets/images/Group 92.png" />
            </div>
          </div>

          <div class="delivery-main-box">
            <img src="@/assets/images/hpcopy/定位.png" alt="" />
            <div class="address">
              <div>目的港</div>
              <el-select  v-model="searchQuery2XCSC" clearable  filterable placeholder="请选择"
                remote
                reserve-keyword
                :remote-method="mdgremoteMethod"
                :loading="mdgloading">
                 <!-- @tab-click="handleClick" -->
                <el-tabs class="mudig" v-model="activeName">
                  <el-tab-pane
                    :key="index"
                      v-for="(item,index) in muDgList"
                    :label="item.route_name"
                    :name="item.route_name"
                  >
                    <el-option-group
                      v-for="(it,idx) in item.tag_arr"
                        :key="idx"
                      :label="it.tag_name"
                      :value="it.tag_id"
                      class="mdglist">
                      <el-option
                        v-for="(at,adx) in it.port_arr"
                          :key="adx"
                        :label="at.port_name+'-'+at.name_en"
                        :value="at.port_id">
                      </el-option>
                    </el-option-group>
                  </el-tab-pane>
                </el-tabs>
              </el-select>
            </div>
          </div>
          <div class="delivery-main-box">
            <img src="@/assets/images/hpcopy/箱型.png" alt="" />
            <div class="address">
              <div>箱型</div>
              <el-select 
              :multiple-limit="3"
              multiple
              collapse-tags
              class="xiangxing"
              clearable
              v-model="searchQuery3XCSC"
              placeholder="请选择">
              <el-option
                v-for="item in boxTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
            </div>
          </div>
          <div class="delivery-main-box">
            <img src="@/assets/images/hpcopy/日期.png" alt="" />
            <div class="address">
              <div>开航起止日期</div>
              <!-- <input type="date" placeholder="开始日期"> -->
              <el-date-picker
                :picker-options="pickerOptions"
                value-format='yyyy-MM-dd'
                prefix-icon="null"
                class="picker"
                v-model="DateValue2"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </div>

          <div class="search"  @click="searchList('XCSC')">
            <i class="el-icon-search"></i>搜索
          </div>
        </div>
        <div v-if="historyPortList.length>0" class="delivery-foot">
          <div class="jilu">历史记录</div>
          <div class="delivery-history-box">
            <div class="delivery-history"
            v-for="(item,index) in historyPortList"
            :key="index"
            @click="historySearch('XCSC',item)"
            >
            {{item.state_port_name}}-{{item.end_port_name}}
          </div>
          </div>
        </div>
      </div>
      <div class="delivery-show" v-if="marketIndex == 2">
        <div class="delivery-main">
          <div class="delivery-main-box youjiantou">
            <img src="@/assets/images/hpcopy/定位.png" alt="" />
            <div class="address">
              <div>起运港</div>
              <el-select @change="changeQyg" v-model="searchQuery1CD" clearable  filterable placeholder="请选择">
                <el-option
                  v-for="item in qiYGTitleList"
                  :key="item.id"
                  :label="item.name_cn+'-'+item.name_en"
                  :value="item.id"
                  v-show="item.display_range==0 || item.display_range==2"
                >
                </el-option>
              </el-select>
            </div>
            <div class="youbian youbianvv">
              <img src="../../assets/images/Group 92.png" />
            </div>
            <div class="switch jiantou">
              <div
                :class="{ switchBackground: isSwitchQY(1) }"
                @click="handleSwitchQY(1)"
              >
                CY
              </div>
              <div
                :class="{ switchBackground: isSwitchQY(2) }"
                @click="handleSwitchQY(2)"
              >
                SD
              </div>
            </div>
          </div>

          <div class="delivery-main-box">
            <img src="@/assets/images/hpcopy/定位.png" alt="" />
            <div class="address">
              <div>目的港</div>
              <el-select @change="changeMdg" v-model="searchQuery2CD" clearable  filterable placeholder="请选择" 
                remote
                reserve-keyword
                :remote-method="mdgremoteMethod"
                :loading="mdgloading">
                 <!-- @tab-click="handleClick" -->
                <el-tabs class="mudig" v-model="activeName">
                  <el-tab-pane
                    :key="index"
                      v-for="(item,index) in muDgList"
                    :label="item.route_name"
                    :name="item.route_name"
                  >
                    <el-option-group
                      v-for="(it,idx) in item.tag_arr"
                        :key="idx"
                      :label="it.tag_name"
                      :value="it.tag_id"
                      class="mdglist">
                      <el-option
                        v-for="(at,adx) in it.port_arr"
                          :key="adx"
                        :label="at.port_name+'-'+at.name_en"
                        :value="at.port_id">
                      </el-option>
                    </el-option-group>
                  </el-tab-pane>
                </el-tabs>
              </el-select>
            </div>
            <div class="switch">
              <div
                :class="{ switchBackground: isSwitchMD(1) }"
                @click="handleSwitchMD(1)"
              >
                CY
              </div>
              <div
                :class="{ switchBackground: isSwitchMD(2) }"
                @click="handleSwitchMD(2)"
              >
                SD
              </div>
            </div>
          </div>
          <div class="delivery-main-box">
            <img src="@/assets/images/hpcopy/箱型.png" alt="" />
            <div class="address">
              <div>箱型</div>
              <el-select 
              :multiple-limit="3"
              multiple
              collapse-tags
              class="xiangxing"
              clearable
              v-model="searchQuery3CD" 
              placeholder="请选择">
              <el-option
                v-for="item in boxTypeListCd"
                :key="item.id"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
            </div>
          </div>
          <div class="delivery-main-box">
            <img src="@/assets/images/hpcopy/日期.png" alt="" />
            <div class="address">
              <div>开航起止日期</div>
              <!-- <input type="date" placeholder="开始日期"> -->
              <el-date-picker
                value-format='yyyy-MM-dd'
                :picker-options="pickerOptions"
                prefix-icon="null"
                class="picker"
                v-model="DateValue3"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </div>

          <div class="search" @click="searchList('CD')">
            <i class="el-icon-search"></i>搜索
          </div>
        </div>
        <div v-if="historyPortList.length>0" class="delivery-foot">
          <div class="jilu">历史记录</div>
          <div class="delivery-history-box">
            <div class="delivery-history"
            v-for="(item,index) in historyPortList"
            :key="index"
            @click="historySearch('CD',item)"
            >
            {{item.state_port_name}}-{{item.end_port_name}}
          </div>
          </div>
        </div>
      </div>
      <div class="delivery-show meijiadaomen" v-if="marketIndex == 3">
        <div class="delivery-main delivery-main-1">
          <div class="delivery-main-box">
            <img src="@/assets/images/hpcopy/xiangxing.png" alt="" />
            <div class="address">
              <div>类型</div>
              <div class="leixing">
                <el-radio v-model="mjdmForm.type" label="1">出口</el-radio>
                <el-radio v-model="mjdmForm.type" label="2">进口</el-radio>
              </div>
              <!-- <span>
                    <img src="@/assets/images/下拉.png" alt="" />
                  </span> -->
            </div>
          </div>
          <div class="delivery-main-box">
            <img src="@/assets/images/hpcopy/guojia.png" alt="" />
            <div class="address">
              <div>国家</div>
              <el-select @change="getPortList" v-model="mjdmForm.country_id" clearable  filterable placeholder="请选择国家">
                <el-option
                  v-for="item in countryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- <div class="delivery-main-box">
            <img src="@/assets/images/hpcopy/定位.png" alt="" />
            <div class="address">
              <div>{{mjdmForm.type==1?'起运港':'卸货港'}}</div>
              <el-select  v-model="mjdmForm.state_port_id" clearable  filterable placeholder="请选择">
                <el-option
                  v-for="item in statePortList"
                  :key="item.id"
                  :label="item.port+'-'+item.port_english"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div> -->
          <!-- <div class="delivery-main-box">
            <img src="@/assets/images/hpcopy/箱型.png" alt="" />
            <div class="address">
              <div>箱型</div>
              <el-select 
              :multiple-limit="3"
              multiple
              collapse-tags
              class="xiangxing"
              clearable
              v-model="mjdmForm.cases_gauge_type_id" 
              placeholder="请选择">
              <el-option
                v-for="item in boxTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            </div>
          </div> -->
          <div class="delivery-main-box">
            <img src="@/assets/images/hpcopy/chengshi.png" alt="" />
            <div class="address">
              <div>{{mjdmForm.type==1?'送达城市(邮编)':'起运城市(邮编)'}}</div>
              <el-select 
              @change="getfujinPort" 
              v-model="mjdmForm.end_city_id" 
              clearable  
              filterable 
              placeholder="请输入"
              remote
              reserve-keyword
              :remote-method="zipCodeRemoteMethod"
              :loading="loading"
              >
                <el-option
                  v-for="item in endPortList"
                  :key="item.id"
                  :label="item.place_name+'('+item.postal_code+')'"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="delivery-main-box">
            <img src="@/assets/images/hpcopy/定位.png" alt="" />
            <div class="address">
              <div>{{mjdmForm.type==1?'卸货港/卸货地':'装货港/装货地'}}</div>
              <el-select v-model="mjdmForm.port_id" clearable  filterable placeholder="请选择">
                <el-option
                  v-for="item in portList"
                  :key="item.id"
                  :label="item.port"
                  :value="item.id"
                >
                </el-option>
                <div>
                  <el-button v-show="chakanShow" class="chakan" type="text" @click="getChakan">查看更多</el-button>
                </div>
              </el-select>
            </div>
          </div>
        </div>
        <div class="huoquyj">
          <el-button type="primary" @click="getFreightRates">获取运价</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Animation from './AnimationPage.vue';
import { 
  basePortValidList,
  destinationPortRouteTypeValidList,
  baseCasesGaugeTypeValidList,
  getPortByCountries,
  getCityList,
  getPortByCityId,
  historyPort
} from "@/api/api";
export default {
  components:{
        Animation,
    },
  props:{

  },
  data() {
    return {
      parentMessage:{
          title:'运价查询',
          content:'实时查询，直达一手运价'
      },
      mdgloading:false,
      // 运货标签
      titleList: ["精选运价", "现舱市场", "船东SPOT", "美加到门"],
      marketIndex: "0",
      //   默认第一个有背景颜色
      highlightBackground: 0,
      // 默认第一个是开的
      highlightSwitchQY: 1,
      highlightSwitchMD: 1,
      // 起运港内容
      qiYGValue: "",
      // 起运港列表
      qiYGTitleList: [],
      muDgList:[],
      boxTypeList: [],
      // 国家
      countryList: [
        {
          "id": 6,
          "name": "美国"
        },
        {
          "id": 7,
          "name": "加拿大"
        }
      ],
      // 邮编
      zipCodeList: ["100000", "110000", "116000", "200000", "210000", "400000"],

      // 发货港口
      searchQuery1JXYJ: "",
      searchQuery1XCSC: "",
      searchQuery1CD: "",
      searchQuery1MJDM: "",

      // 收货港口
      searchQuery2JXYJ: "",
      searchQuery2XCSC: "",
      searchQuery2CD: "",
      searchQuery2MJDM: "",

      // 箱型
      searchQuery3JXYJ: [],
      searchQuery3XCSC: [],
      searchQuery3CD: [],
      searchQuery3MJDM: [],
      boxTypeListCd:[
        {
          "id": 17,
          "name": "20GP"
        },
        {
          "id": 18,
          "name": "40GP"
        },
        {
          "id": 19,
          "name": "40HQ"
        }
      ],
      // 国家
      countryText: "",
      // 邮编
      zipCodeText: "",

      // 日期
      DateValue1: "",
      DateValue2: "",
      DateValue3: "",

      // 进出口单选框
      radio: "1",

      mjdmForm:{
        type:'1', // 进出口：1出口、2进口
        country_id:6, // 国家id
        state_port_id:'', // 起运港ID | 卸货港ID
        end_city_id:'',  // 送达城市ID | 起运城市ID
        port_id:'', // 卸货港、卸货地ID | 装货港、装货地ID
        cases_gauge_type_id:'', //箱规ID
      },
      statePortList:[], //美加到门起运港
      endPortList:[], // 美加到门送达城市
      portList:[], // 美加到门卸货港卸货地
      chakanShow:true,
      loading: false,
      historyPortList:[], // 历史记录
      activeName:'',
      statePortForm:{},
      endPortForm:{},
      pickerOptions1:{
        disabledDate(time) {
          //Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return (time.getTime() - 2 * 3600 * 1000 * 24) < Date.now() - 8.64e7;
        }
      },
      pickerMinDate: null,
      pickerMaxDate: null,
      daySanshi: 30 * 24 * 3600 * 1000,
      pickerOptions: {
          onPick: ({  minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (time.getTime() - 2 * 3600 * 1000 * 24) < Date.now() - 8.64e7 || (time.getTime() > (this.pickerMinDate + this.daySanshi)) || (time.getTime() < (this.pickerMinDate - this.daySanshi));
          }
          //  return false;
          return (time.getTime() - 2 * 3600 * 1000 * 24) < Date.now() - 8.64e7
        }
      },
      keywordA:''
    };
  },
  methods: {
    changeQyg(value){
          for (let i = 0; i < this.qiYGTitleList.length; i++) {
              if(this.qiYGTitleList[i].id ==value){
              this.statePortForm = this.qiYGTitleList[i]
              }
          }
      },
      changeMdg(value){
          for (let i = 0; i < this.muDgList.length; i++) {
              for (let j = 0; j < this.muDgList[i].tag_arr.length; j++) {
              for (let k = 0; k < this.muDgList[i].tag_arr[j].port_arr.length; k++) {
                if(this.muDgList[i].tag_arr[j].port_arr[k].port_id==value){
                  this.endPortForm = this.muDgList[i].tag_arr[j].port_arr[k]
                }
              }
              }
          }
      },
    // 点击送货标签
    handleClickTitle(index) {
      this.highlightBackground = index;
      this.marketIndex = index;
      this.getMdgList()
    },
    // 触发背景颜色
    isBackground(index) {
      return this.highlightBackground === index;
    },
    // 点击开关
    handleSwitchQY(val) {
      this.highlightSwitchQY = val;
    },
    handleSwitchMD(val) {
      this.highlightSwitchMD = val;
    },
    // 点击开关--显示样式
    isSwitchQY(val) {
      return this.highlightSwitchQY === val;
    },
    isSwitchMD(val) {
      return this.highlightSwitchMD === val;
    },
    // 目的港切换标签内容
    // handleClick(tab, event) {
    //   console.log(tab, event);
    // },
    // 邮编
    zipCodeHandleCommand(command) {
      this.zipCodeText = command;
    },
    // 起运港
    async getQygList() {
      // 起运港列表
      let basePortParams = {
        page_no: 1,
        page_size: 50,
        keyword: '',
      };
      const basePortRes = await basePortValidList(basePortParams);
      if (basePortRes.code==1) {
        this.qiYGTitleList=basePortRes.data.lists
      }
    },
    // 目的港
    async getMdgList(e) {
        this.mdgloading = true;
        if(e==undefined){
          e=''
        }
        // 目的港列表
        const res = await destinationPortRouteTypeValidList({
            keyword:e
          });
        if (res.code==1) {
          this.muDgList=res.data
          if(res.data.length>0){
            this.activeName=res.data[0].route_name
          }
          this.mdgloading = false
        }
      },
      mdgremoteMethod(query){
        if (query !== '') {
          setTimeout(async () => {
            this.getMdgList(query)
          }, 200);
        } else {
          this.getMdgList();
        }
      },
    // 箱型
    async getBoxTypeList() {
      // 目的港列表
      const res = await baseCasesGaugeTypeValidList();
      if (res.code==1) {
        this.boxTypeList=res.data
      }
    },
    searchList(e){
      // 判断是否登录
      let isLogin = localStorage.getItem('isLogin')
      if( !isLogin){
        // this.$message({
        //   type:'error',
        //   message:'请先进行登录/注册',
        // })
        // 
        // 子传父
        this.$emit("message", {
          dialogVisibleLogin: true,
        });
        return
      }
      let statePortForm=''
      let endPortForm=''
        

        if(e=='JXYJ'){
          sessionStorage.setItem("lineIndex", 1);
          for (let i = 0; i < this.qiYGTitleList.length; i++) {
              if(this.qiYGTitleList[i].id ==this.searchQuery1JXYJ){
                statePortForm = this.qiYGTitleList[i].name_cn+'-'+this.qiYGTitleList[i].name_en
              }
          }

          for (let i = 0; i < this.muDgList.length; i++) {
            for (let j = 0; j < this.muDgList[i].tag_arr.length; j++) {
              for (let k = 0; k < this.muDgList[i].tag_arr[j].port_arr.length; k++) {
                if(this.muDgList[i].tag_arr[j].port_arr[k].port_id==this.searchQuery2JXYJ){
                  endPortForm = this.muDgList[i].tag_arr[j].port_arr[k].port_name+'-'+this.muDgList[i].tag_arr[j].port_arr[k].name_en
                }
              }
            }
          }
          if (this.searchQuery1JXYJ=='') {
            this.$message({
              type:'error',
              message:'请选择起运港'
            })
            return
          }else if(this.searchQuery2JXYJ==''){
            this.$message({
              type:'error',
              message:'请选择目的港'
            })
            return
          }else if(this.searchQuery3JXYJ.length==0){
            this.$message({
              type:'error',
              message:'请选择箱型'
            })
            return
          }else{
            let param = {
              qi:this.searchQuery1JXYJ,
              statePortForm:statePortForm,
              endPortForm:endPortForm,
              mu:this.searchQuery2JXYJ,
              boxtype:this.searchQuery3JXYJ,
              createTime:this.DateValue1[0],
              endTime:this.DateValue1[1]
            }
            this.$router.push({
              name:'SearchResults',
              params:param
            })
          }
          
        }else if(e=='XCSC'){
          sessionStorage.setItem("lineIndex", 2);
          for (let i = 0; i < this.qiYGTitleList.length; i++) {
              if(this.qiYGTitleList[i].id ==this.searchQuery1XCSC){
                statePortForm = this.qiYGTitleList[i].name_cn+'-'+this.qiYGTitleList[i].name_en
              }
          }

          for (let i = 0; i < this.muDgList.length; i++) {
            for (let j = 0; j < this.muDgList[i].tag_arr.length; j++) {
              for (let k = 0; k < this.muDgList[i].tag_arr[j].port_arr.length; k++) {
                if(this.muDgList[i].tag_arr[j].port_arr[k].port_id==this.searchQuery2XCSC){
                  endPortForm = this.muDgList[i].tag_arr[j].port_arr[k].port_name+'-'+this.muDgList[i].tag_arr[j].port_arr[k].name_en
                }
              }
            }
          }

          if (this.searchQuery1XCSC=='') {
            this.$message({
              type:'error',
              message:'请选择起运港'
            })
            return
          }else if(this.searchQuery2XCSC==''){
            this.$message({
              type:'error',
              message:'请选择目的港'
            })
            return
          }else if(this.searchQuery3XCSC.length==0){
            this.$message({
              type:'error',
              message:'请选择箱型'
            })
            return
          }else {
            let param = {
              qi:this.searchQuery1XCSC,
              mu:this.searchQuery2XCSC,
              statePortForm:statePortForm,
              endPortForm:endPortForm,
              boxtype:this.searchQuery3XCSC,
              createTime:this.DateValue2[0],
              endTime:this.DateValue2[1]
            }
            this.$router.push({
              name:'MarketSearchResults',
              params:param
            })
          }
        }else if(e=='CD'){
          sessionStorage.setItem("lineIndex", 3);
          let qygName=''
          let mdgName=''
          for (let i = 0; i < this.qiYGTitleList.length; i++) {
              if(this.qiYGTitleList[i].id ==this.searchQuery1CD){
                statePortForm = this.qiYGTitleList[i]
                qygName = this.qiYGTitleList[i].name_cn+'-'+this.qiYGTitleList[i].name_en
              }
          }

          for (let i = 0; i < this.muDgList.length; i++) {
            for (let j = 0; j < this.muDgList[i].tag_arr.length; j++) {
              for (let k = 0; k < this.muDgList[i].tag_arr[j].port_arr.length; k++) {
                if(this.muDgList[i].tag_arr[j].port_arr[k].port_id==this.searchQuery2CD){
                  endPortForm = this.muDgList[i].tag_arr[j].port_arr[k]
                  mdgName = this.muDgList[i].tag_arr[j].port_arr[k].port_name+'-'+this.muDgList[i].tag_arr[j].port_arr[k].name_en
                }
              }
            }
          }

          if (this.searchQuery1CD=='') {
            this.$message({
              type:'error',
              message:'请选择起运港'
            })
            return
          }else if(this.searchQuery2CD==''){
            this.$message({
              type:'error',
              message:'请选择目的港'
            })
            return
          }else if(this.searchQuery3CD.length==0){
            this.$message({
              type:'error',
              message:'请选择箱型'
            })
            return
          }else {
            let param = {
              statePortForm:statePortForm,
              endPortForm:endPortForm,
              qygName:qygName,
              mdgName:mdgName,
              qi:this.searchQuery1CD,
              mu:this.searchQuery2CD,
              boxtype:this.searchQuery3CD,
              createTime:this.DateValue3[0],
              endTime:this.DateValue3[1]
            }
            this.$router.push({
              name:'ShipSPOTSearchResults',
              params:param
            })
          }
        }
    },

    // 美加到门  起运港
    async getPortList(){
      let params = {
        page_no: 1,
        page_size: 10,
        countries_id: this.mjdmForm.country_id,
      };
      const res = await getPortByCountries(params);
      if (res.code==1) {
        this.statePortList=res.data.lists
      }
    },
    // statePortList:[], //美加到门起运港
    // endPortList:[], // 美加到门送达城市
    // portList:[], // 美加到门卸货港卸货地
    // 美加到门 城市邮编
    async getZipCodeList(){
      // if(this.mjdmForm.end_city_id!=''){
        let params = {
          page_no: 1,
          page_size: 10,
          countries_id:this.mjdmForm.country_id,
          keyword: this.mjdmForm.end_city_id,
        };
        const res = await getCityList(params);
        if (res.code==1) {
          this.endPortList=res.data.lists
        }
      // }else{
        // this.endPortList=[]
      // }
      
    },
    // 城市邮编 远程搜索
    zipCodeRemoteMethod(query) {
      if (query !== '') {
        // this.loading = true;
        setTimeout(() => {
          // this.loading = false;
          this.mjdmForm.end_city_id = query
          this.keywordA = query
          this.getZipCodeList()
        }, 200);
      } else {
        this.endPortList = [];
      }
    },
    // 获取附近港口
    async getfujinPort(){
      this.mjdmForm.port_id=''
      // if(this.mjdmForm.end_city_id!=''){
        let params = {
          page_no: 1,
          page_size: 3,
          countries_id:this.mjdmForm.country_id,
          end_city_id:this.mjdmForm.end_city_id,
        };
        const res = await getPortByCityId(params);
        if (res.code==1) {
          this.portList=res.data.lists
          this.mjdmForm.port_id =  res.data.lists[0].id
        }
      // }else{
        // this.endPortList=[]
      // }
      
    },
    async getChakan(){
      this.mjdmForm.port_id=''
    // if(this.mjdmForm.end_city_id!=''){
      let params = {
        page_no: 1,
        page_size: 0,
        countries_id:this.mjdmForm.country_id,
        end_city_id:this.mjdmForm.end_city_id,
      };
      const res = await getPortByCityId(params);
      if (res.code==1) {
        this.portList=res.data.lists
        this.mjdmForm.port_id =  res.data.lists[0].id
        this.chakanShow=false
      }
    },
    // 获取运价  跳转到美加到门页面
    getFreightRates(){
      sessionStorage.setItem("lineIndex", 4);
      let isLogin = localStorage.getItem('isLogin')
      if( !isLogin){
        // this.$message({
        //   type:'error',
        //   message:'请先进行登录/注册',
        // })
        // 
        // 子传父
        this.$emit("message", {
          dialogVisibleLogin: true,
        });
        return
      }

      let word = '送达城市(邮编)'
      let worder = '卸货港/卸货地'
      if(this.mjdmForm.type==1){
        word = '送达城市(邮编)'
        worder = '卸货港/卸货地'
      }else{
        word = '起运城市(邮编)'
        worder = '装货港/装货地'
      }
      
      if (this.mjdmForm.country_id=='') {
        this.$message({
          type:'error',
          message:'请选择国家'
        })
      }
      // else if (this.mjdmForm.state_port_id=='') {
      //   this.$message({
      //     type:'error',
      //     message:'请选择起运港'
      //   })
      // }
      else if (this.mjdmForm.end_city_id=='') {
        this.$message({
          type:'error',
          message:'请选择' + word
        })
      }else if (this.mjdmForm.port_id=='') {
        this.$message({
          type:'error',
          message:'请选择' + worder
        })
      }
      // else if (this.mjdmForm.cases_gauge_type_id=='') {
      //   this.$message({
      //     type:'error',
      //     message:'请选择箱型',
      //   })
      // }
      else{
        this.mjdmForm.keywordA = this.keywordA
        sessionStorage.setItem('mjdm',JSON.stringify(this.mjdmForm))
        this.$router.push({
          name:'USToDoor',
          params:this.mjdmForm
        })
      }
    },
    async getHistoryPort(){
      this.mjdmForm.port_id=''
      try {
        // if(this.mjdmForm.end_city_id!=''){
          const res = await historyPort({
            token:localStorage.getItem('token')
          });
          if (res.code==1) {
            this.historyPortList=res.data
          }
      } catch (error) {
        this.$message({
          type:'error',
          message:'登录超时，请重新登录'
        })
        console.log('失败',error);
      }
      
      
    },
    historySearch(activeName,res){
      if(activeName=='JXYJ'){
        this.searchQuery1JXYJ=res.state_port_id
        this.searchQuery2JXYJ=res.end_port_id
      }else if(activeName=='XCSC'){
        this.searchQuery1XCSC=res.state_port_id
        this.searchQuery2XCSC=res.end_port_id
      }else if(activeName=='CD'){
        this.searchQuery1CD=res.state_port_id
        this.searchQuery2CD=res.end_port_id
      }
    },
    // 处理时间
    changeDate(){
      var date = new Date();
          var year = date.getFullYear().toString();
          var currentYear = date.getFullYear().toString();
          var month = (date.getMonth() + 1).toString();
          var day = (date.getDate()+2).toString();
          var sanshiyi = ['1','3','5','7','8','10','12']
          var sanshi = ['4','6','9','11']
          var ershiba = '2'

          if(sanshiyi.includes(month)){
            if(month>=12){
              if(day>31){
                day = Number(day)-31
                month = Number(month)-11
                year = Number(year)+1
              }
            }
            if(day>31){
              day = Number(day)-31
              month = Number(month)+1
            }
          }else if(sanshi.includes(month)){
            if(day>30){
              day = Number(day)-30
              month = Number(month)+1
            }
          }else if(month==ershiba){
            let run = 28
            if(year %4 == 0 && year %100 != 0 && year % 400 == 0){
              run = 29
            }
            if(day>run){
              day = Number(day)-Number(run)
              month = Number(month)+1
            }
          }

          var currentMonth = String(month);
          var currentDay = String(Number(day)+30);

          if(sanshiyi.includes(currentMonth)){
            if(currentMonth>=12){
              if(currentDay>31){
                currentDay = Number(currentDay)-31
                currentMonth = Number(currentMonth)-11
                currentYear = Number(currentYear)+1
              }
            }
            if(currentDay>31){
              currentDay = Number(currentDay)-31
              currentMonth = Number(currentMonth)+1
            }
          }else if(sanshi.includes(currentMonth)){
            if(currentDay>30){
              currentDay = Number(currentDay)-30
              currentMonth = Number(currentMonth)+1
            }
          }else if(currentMonth==ershiba){
            let run = 28
            if(year %4 == 0 && year %100 != 0 && year % 400 == 0){
              run = 29
            }
            if(currentDay>run){
              currentDay = Number(currentDay)-Number(currentDay)
              currentMonth = Number(currentMonth)+1
            }
          }

          // 对月份和日期进行补零
          month = month <10 ? '0' + month : month;
          currentMonth = currentMonth <10 ? '0' + currentMonth : currentMonth;
          day = day < 10 ? '0' + day : day;
          currentDay = currentDay < 10 ? '0' + currentDay : currentDay;
          
          var currentDate = year + '-' + month + '-' + day ;
          var currentDateER = currentYear + '-' + currentMonth + '-' + currentDay;

      this.DateValue1 = [currentDate, currentDateER]
      this.DateValue2 = [currentDate, currentDateER]
      this.DateValue3 = [currentDate, currentDateER]
    }
  },
  mounted() {
    this.getQygList();
    this.getMdgList();
    this.getBoxTypeList();

    // 查询历史记录
    this.getHistoryPort()
    // this.getPortList();
    // this.getZipCodeList()

    this.changeDate()    
  },
};
</script>

<style lang="scss" scoped>
div {
  display: inline-block;
}
.jingxyj {
  // height: 320px;
  // background: rgba(255, 255, 255, 0.9);
  // box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.05);
  // border-radius: 12px 12px 12px 12px;
  // border: 1px solid #e4e6e8;
  // margin-bottom: 20px;

  // padding: 24px;
  text-align: left;
  box-sizing: border-box;

  .huoquyj {
    width: 100%;
    text-align: right;
    margin: 14px 0;
    .el-button {
      width: 120px;
      height: 48px;
      background: #0073f5;
      border-radius: 8px 8px 8px 8px;
      font-size: 16px;
      color: #ffffff;
    }
  }

  .delivery-show{
    // width: 1776px;
    // height: 309px;
    background: #FFFFFF;
    border-radius: 0px 12px 0px 0px;
    // border: 1px solid #E5E6F0;
    padding: 32px 32px 24px 32px;
    box-sizing: border-box;
    // box-shadow: 0px 2px 31px 0px rgba(12,48,88,0.08);
    box-shadow: 0px -2px 31px 0px rgba(12,48,88,0.08);
  }
}

.meijiadaomen {
  .address {
    width: 100% !important;
    // div:first-child{
    //   color: #666;
    // }
    input {
      color: #333;
      margin-top: 4px;
    }

    .leixing{
      margin-top: 8px;
    }

    :deep(.el-radio){
      margin-top: 8px;
      font-size: 20px;
      .el-radio__label{
        font-size: 20px;
      }
    }
  }
}

.titleBox {
  .title {
    // 鼠标样式
    cursor: pointer;
    width: 181px;
    height: 54px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #43597B;
    line-height: 54px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    background-image:url('@/assets/images/hpcopy/cardBj.png');	
    background-repeat: no-repeat;
    background-size:100% 100%;
  }

  // 送货点击样式
  .background {
    background-image:url('@/assets/images/hpcopy/cardBjHei.png');	
    background-repeat: no-repeat;
    background-size:100% 100%;
    color: #ffffff !important;
    font-size: 20px;
  }

  .backgroundBaiER{
    background-image:url('@/assets/images/hpcopy/cardBjYi.png');	
  }
  
  .backgroundER{
    background-image:url('@/assets/images/hpcopy/cardBjYiHei.png');	
    background-repeat: no-repeat;
    background-size:100% 100%;
    color: #ffffff !important;
    font-size: 20px;
  }

}

.delivery-main {
  width: 1712px;
  height: 118px;
  background: #f9f9f9;
  border-radius: 8px 8px 8px 8px;
  // margin-top: 20px;
  box-sizing: border-box;
  padding: 32px 24px ;
  display: flex;
  justify-content: space-between;
  .delivery-main-box {
    border-right: 1px solid #ddd;
    padding-right: 8px;
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:nth-child(-n + 2) {
      width: 349px;
    }
    &:nth-child(n + 2) {
      margin-left: 8px;
    }
    &:nth-child(3) {
      width: 325px;
      input {
        width: 130px;
      }
    }
    &:nth-child(4) {
      border: 0;
      width: 366px;
    }
    .dateSpan {
      margin-right: 12px;
    }
    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
    .address {
      width: 394px;
      // div:first-child{
      //   color: #666;
      // }
      div {
        display: block;
        height: 20px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      input {
        width: 100%;
        border: none;
        outline: none;
        background: #f9f9f9;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      input {
        color: #333;
        margin-top: 4px;
      }
      
      .el-icon-date:before {
        content: "";
      }
      .el-input {
        display: inline-block;
        width: 80px;
      }
      .el-input--prefix .el-input__inner {
        padding-left: 0;
        padding-right: 0;
        width: 80px;
        height: 20px;
        font-size: 14px;
        display: inline-block;
      }

      :deep(.el-select){
        input{
          background: #f9f9f9;
          border:0;
          padding: 0;
          font-size: 20px;
          color: #333333;
        }
        input::placeholder {
          font-size: 20px;
          color: #999999;
        }
      }

      :deep(.el-tag){
        .el-select__tags-text{
          font-size: 20px;
        }
      }
      
     
    }

    // 选择开关
    .switch {
      width: 100px;
      height: 34px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      box-sizing: border-box;
      padding: 4px;
      display: flex;
      div {
        // width: 43px;
        height: 100%;
        border-radius: 8px 8px 8px 8px;
        color: #999999;
        padding: 3px 7px;
        font-size: 14px;
        box-sizing: border-box;
        &:nth-child(1) {
          margin-right: 4px;
        }
      }
      .switchBackground {
        background: #064FAF;
        color: #ffffff;
      }
    }
  }
  .search {
    cursor: pointer;
    width: 102px;
    height: 49px;
    background: #064FAF;
    border-radius: 6px 6px 6px 6px;
    display: flex;
    justify-content: center;
    align-items: center;

    font-weight: 500;
    font-size: 18px;
    color: #fff;
    i {
      font-size: 20px;
      margin-right: 6px;
    }
  }

  // 日期选择器
  :deep(.el-date-editor) {
    width: 366px;
    border: 0px;
    background: #f9f9f9;
    padding: 0;
    display: flex;
    align-items: baseline;
    justify-content: space-around;
    height: 20px;
    .el-range-input{
      width: 104px;
      text-align: left;
    }

    input {
      background: #f9f9f9;
      border:0;
      padding: 0;
      font-size: 20px;
      color: #333333;
    }
    i.el-input__icon.el-range__icon.null {
      width: 0px;
    }
    .el-date-editor .el-range-separator {
      height: 20px;
    }

    input::placeholder {
      font-size: 20px;
      color: #999999;
    }
  }
}
.delivery-main-1 {
  flex-wrap: wrap;
  padding-bottom: 0;
  .delivery-main-box {
    margin-bottom: 16px;
    &:nth-child(n + 1) {
      width: 360px;
    }
    // &:nth-child(n + 2) {
    //   margin-left: 8px;
    // }
    &:nth-child(3n) {
      border-right: 1px solid #ddd;
    }
    &:nth-child(4) {
      margin-left: 0px;
    }
  }
}

.youjiantou {
  position: relative;
  .youbian {
    position: absolute;
    // left: 316px;
    top: 18px;
    right: -18px;
  }
  .youbianvv {
    top: 13px;
  }
}

.jiantou {
  margin-right: 10px;
}

.delivery-foot {
  margin-top: 24px;
  // margin-bottom: 24px;
  .jilu {
    width: 80px;
    height: 28px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #1E406D;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 6px;
  }
  .delivery-history-box {
    .delivery-history {
      // 鼠标样式
      cursor: pointer;
      background: #F9F9F9;
      border-radius: 4px 4px 4px 4px;
      padding: 8px 18px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #424F62;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-right: 8px;
      margin-bottom: 8px;
    }
  }
}

.el-dropdown {
  position: relative;
  span {
    position: absolute;
    top: 12px;
    right: 20px;
  }
}
// 下拉港口
.noDate {
  padding: 20px;
  color: #666;
}
.el-dropdown-menu {
  :deep(.el-tabs__nav is-top) {
    font-size: 16px !important;
  }
  .el-tabs {
    padding: 0 20px;
    width: 500px;
    .xianDiv {
      padding: 10px;
      color: #666;
      font-size: 14px;
      width: 160px;
      text-align: left;
      display: inline-block;
    }
    .xianDiv:hover {
      color: #0073f5;
    }
  }
}
.el-dropdown-menu__item {
  font-size: 16px;
}
.el-dropdown-menu {
  // width: 720px;
  // height: 240px;
  background: #fff;
  // position: absolute;
  // top: 0;
  // left: 10px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px 12px 12px 12px;
  // // padding: 24px 0;
  // box-sizing: border-box;
  // // 显示滚动条
  overflow-y: auto;
  overflow-x: hidden;

  // cursor: pointer;
  .dropdown {
    .dropdown-header-box {
      width: 720px;
      border-bottom: 1px solid #eee;
      padding: 0 24px;
      box-sizing: border-box;
      // padding-bottom: 17px;

      .dropdown-header {
        margin-right: 32px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #999999;
        line-height: 19px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }

    .dropdown-main,
    .dropdown-main-title {
      display: block;
    }

    .dropdown-main {
      padding: 24px;
      .dropdown-main-title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        border-left: 2px solid #0073f5;
        padding-left: 8px;
      }
      .dropdown-main-content {
        margin-top: 16px;

        .dropdown-main-content-box {
          width: 162px;
          padding: 8px 24px 8px 12px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #666666;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          box-sizing: border-box;

          // 超出隐藏
          overflow: hidden; /* 隐藏超出部分 */
          white-space: nowrap; /* 不换行 */
          text-overflow: ellipsis; /* 超出部分显示为省略号 */
        }
      }
    }
    .dropdown-main-2 {
      padding-top: 0;
    }
  }
}
// 下拉港口点击样式
.dropdownTitle {
  color: #0073f5 !important;
  border-bottom: 2px solid #0073f5;
  padding-bottom: 16px;
}
// 选择具体地区样式
.dropdownContent {
  color: #0073f5 !important;
  border: 1px solid #0073f5;
  background: #edf6ff;
}

// 导航点击样式
.border-bottom {
  border-bottom: 4px solid #fff;
  border-radius: 2px 2px 0px 0px;
  padding-bottom: 8px;
}

.spanA {
  color: #0073f5 !important;
}

.border-bottomA {
  border-bottom: 4px solid #0073f5;
  border-radius: 2px 2px 0px 0px;
  padding-bottom: 8px;
}

// 导航栏展示样式
.showList {
  color: #0073f5 !important;
  background: #edf6ff;
}

.mudig{
  padding: 10px 20px 20px 20px;
  box-sizing: border-box;
  width: 500px;
  .mdglist{
    :deep(.el-select-group){
      display: flex;
      flex-wrap: wrap;
    }
  }
  :deep(.el-select){
    ul.el-select-group{
      display: flex;
    }
  }
}

.xiangxing{
  :deep(.el-select__tags){
    margin-top: 10px;
    span.el-tag.el-tag--info.el-tag--small.el-tag--light{
          margin: 2px 6px 2px 0;
    }
  }
}

.chakan{
  margin-left: 20px;
}
</style>